 

/**/
/*var elements = document.querySelectorAll(".btn-modal");
elements.forEach(element => {
    //alert('hola mundo');
    element.addEventListener("click", function(e) {
        document.getElementById('overlay').classList.add('is-visible');
        document.getElementById('modal').classList.add('is-visible');
        document.querySelector('.template-product').classList.add('disable-scrolling');
        console.log(e.target.innerText);
    });
});
*/
/*
document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.btn-modal').forEach((div)=>{
        div.addEventListener('click', clickEvent);
    });
});

function clickEvent(e){    
    document.getElementById('overlay').classList.add('is-visible');
    document.getElementById('modal').classList.add('is-visible');
    document.querySelector('.template-product').classList.add('disable-scrolling');
    console.log(e.target.innerText);
 }

document.getElementById('close-about-modal').addEventListener('click', function() {
    document.getElementById('overlay').classList.remove('is-visible');
    document.getElementById('modal').classList.remove('is-visible');
    document.querySelector('.template-product').classList.remove('disable-scrolling');
});

document.getElementById('overlay').addEventListener('click', function() {
    document.getElementById('overlay').classList.remove('is-visible');
    document.getElementById('modal').classList.remove('is-visible');
    document.querySelector('.template-product').classList.remove('disable-scrolling');
});
*/


document.addEventListener('DOMContentLoaded', function () {
    const modalButtons = document.querySelectorAll('.btn-modal');
    const overlay = document.getElementById('overlay');
    const modal = document.getElementById('modal');
    const closeButton = document.getElementById('close-about-modal');
    const templateProduct = document.querySelector('.template-product');

    // Verifica si existen botones para abrir el modal
    if (modalButtons.length > 0) {
        modalButtons.forEach((button) => {
            button.addEventListener('click', function (e) {
                if (overlay && modal && templateProduct) {
                    overlay.classList.add('is-visible');
                    modal.classList.add('is-visible');
                    templateProduct.classList.add('disable-scrolling');
                    console.log(e.target.innerText);
                }
            });
        });
    }

    // Verifica si existe el botón de cierre del modal
    if (closeButton) {
        closeButton.addEventListener('click', function () {
            if (overlay && modal && templateProduct) {
                overlay.classList.remove('is-visible');
                modal.classList.remove('is-visible');
                templateProduct.classList.remove('disable-scrolling');
            }
        });
    }

    // Verifica si existe el overlay
    if (overlay) {
        overlay.addEventListener('click', function () {
            if (modal && templateProduct) {
                overlay.classList.remove('is-visible');
                modal.classList.remove('is-visible');
                templateProduct.classList.remove('disable-scrolling');
            }
        });
    }
}); 

